import { api } from '../../shared/api/client';
import type { Paged } from '../patients/types';

export interface Clinic {
  id: string;
  name: string;
  city: string;
  address: string;
  phone: string;
  createdAt: string;
  updatedAt: string;
}

export interface ClinicInput {
  name: string;
  city?: string;
  address?: string;
  phone?: string;
}

export async function listClinics(
  params: { search?: string; limit?: number; offset?: number } = {},
): Promise<Paged<Clinic>> {
  const { data } = await api.get<Paged<Clinic>>('/v1/clinics', { params });
  return data;
}

export async function createClinic(body: ClinicInput): Promise<Clinic> {
  const { data } = await api.post<Clinic>('/v1/clinics', body);
  return data;
}

export async function updateClinic(id: string, body: ClinicInput): Promise<Clinic> {
  const { data } = await api.patch<Clinic>(`/v1/clinics/${id}`, body);
  return data;
}

export async function deleteClinic(id: string): Promise<void> {
  await api.delete(`/v1/clinics/${id}`);
}
